import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IHeadingListItem {
	/**
	 * Item Subheading
	 */
	subheading?: string;
	/**
	 * Item Text
	 */
	text?: string;
}

export interface INumberedHeadingListProps extends IBaseElementProps {
	/**
	 * Numbered Heading List Heading
	 */
	heading?: string;
	/**
	 * Numbered Heading List Items
	 */
	items?: IHeadingListItem[];
}

/**
 * Numbered Heading List
 * @block
 * @icon saved
 */
const NumberedHeadingList: React.FC<INumberedHeadingListProps> = ({
	heading,
	items = [],
	id,
	className,
	classNames = [],
}) => (
	<div
		id={id}
		className={
			className || cn('calian-numbered-heading-list', ...classNames)
		}
	>
		{heading && (
			<h3 className="calian-numbered-heading-list__heading">{heading}</h3>
		)}
		{items.length > 0 && (
			<ol className="calian-numbered-heading-list__items">
				{items.map(({ subheading, text }, index) => (
					<li
						className="calian-numbered-heading-list__item"
						key={index}
					>
						{subheading && (
							<h4 className="calian-numbered-heading-list__subheading">
								<span className="calian-numbered-heading-list__number">
									{index + 1}.
								</span>
								{subheading}
							</h4>
						)}
						{text && (
							<p className="calian-numbered-heading-list__text">
								{text}
							</p>
						)}
					</li>
				))}
			</ol>
		)}
	</div>
);

export default NumberedHeadingList;
